import React from 'react';
import { Route } from 'react-router';

import CoachingAvailabilityContainer from 'coaching/CoachingAvailabilityContainer';
import CoachingChatStreamContainer from 'coaching/CoachingChatStreamContainer';
import CoachingConstants from 'coaching/CoachingConstants';
import CoachingCoordinatorContainer from 'coaching/CoachingCoordinatorContainer';
import CoachingSelfServeContainer from 'coaching/CoachingSelfServeContainer';
import CoachingIntroContainer from 'coaching/CoachingIntroContainer';
import CoachingHomeContainer from 'coaching/CoachingHomeContainer';
import CoachingHelpContainer from 'coaching/CoachingHelpContainer';
import CoachingHelpFormContainer from 'coaching/CoachingHelpFormContainer';
import CoachingCoachHelpContainer from 'coaching/CoachingCoachHelpContainer';
import CoachingCoachHelpFormContainer from 'coaching/CoachingCoachHelpFormContainer';
import chainOnEnter from 'components/lib/chainOnEnter';
// @ts-ignore
import RequireUser from 'lib/RequireUser';
// @ts-ignore
import RequireSetup from 'lib/RequireSetup';
import RequireLoginWithAuthToken from 'lib/RequireLoginWithAuthToken';
import AcceptCoachingInvitation from 'coaching/components/AcceptCoachingInvitation';
import { redirectIfMobile, redirectIfDesktop } from 'coaching/lib/deviceType';

export const CoachingIsolatedRoutes = (
  <>
    <Route
      path={CoachingConstants.COACHING_PURCHASE_INTRO_ROUTE}
      component={CoachingIntroContainer}
    />
    <Route
      path={CoachingConstants.COACHING_PURCHASE_REVIEW_ROUTE}
      component={CoachingSelfServeContainer}
      onEnter={RequireUser}
    />
    <Route
      path={CoachingConstants.COACHING_COORDINATOR_ROUTE}
      component={CoachingCoordinatorContainer}
      onEnter={RequireUser}
    />
    <Route
      path={CoachingConstants.COACHING_ACCEPT_INVITATION_ROUTE}
      onEnter={chainOnEnter([RequireLoginWithAuthToken, RequireUser, RequireSetup])}
      component={AcceptCoachingInvitation}
    />
    {/* No left nav bar on mobile home */}
    <Route
      path={CoachingConstants.COACHING_HOME_MOBILE_ROUTE}
      component={CoachingHomeContainer}
      onEnter={chainOnEnter([
        redirectIfDesktop(CoachingConstants.COACHING_HOME_ROUTE),
        RequireUser,
      ])}
    />
    <Route
      path={CoachingConstants.COACHING_AVAILABILITY_MOBILE_ROUTE}
      component={CoachingAvailabilityContainer}
      onEnter={chainOnEnter([
        redirectIfDesktop(CoachingConstants.COACHING_AVAILABILITY_ROUTE),
        RequireUser,
      ])}
    />
    <Route path={CoachingConstants.COACHING_HELP_ROUTE} component={CoachingHelpContainer} />
    <Route
      path={CoachingConstants.COACHING_HELP_FORM_ROUTE}
      component={CoachingHelpFormContainer}
    />
    <Route
      path={CoachingConstants.COACHING_COACH_HELP_ROUTE}
      component={CoachingCoachHelpContainer}
    />
    <Route
      path={CoachingConstants.COACHING_COACH_HELP_FORM_ROUTE}
      component={CoachingCoachHelpFormContainer}
    />
  </>
);

export const CoachingRoutes = (
  <>
    <Route
      path={CoachingConstants.COACHING_CHAT_STREAM_ROUTE}
      component={CoachingChatStreamContainer}
      onEnter={RequireUser}
    />
    <Route
      path={CoachingConstants.COACHING_AVAILABILITY_ROUTE}
      component={CoachingAvailabilityContainer}
      onEnter={chainOnEnter([
        redirectIfMobile(CoachingConstants.COACHING_AVAILABILITY_MOBILE_ROUTE),
        RequireUser,
      ])}
    />
    <Route
      path={CoachingConstants.COACHING_HOME_ROUTE}
      component={CoachingHomeContainer}
      onEnter={chainOnEnter([
        redirectIfMobile(CoachingConstants.COACHING_HOME_MOBILE_ROUTE),
        RequireUser,
      ])}
    />
  </>
);
